<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="headline">{{ $tc('title.foco_da_acao', 1)}}</v-expansion-panel-header>
    <v-expansion-panel-content>
      <card-info :campos="campos" :objeto="formatarObjeto()" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import CardInfo from '../../../shared-components/CardInfo';

export default {
  props: {
    acao: Object,
  },
  components: {
    CardInfo,
  },
  data() {
    return {
      campos: [
        { campo: 'cliente', label: this.$tc('label.cliente', 1), hint: 'cnpj' },
        { campo: 'holding', label: this.$tc('label.holding', 1) },
        { campo: 'regional', label: this.$tc('label.regional', 1) },
        { campo: 'tipoPagamento', label: this.$tc('label.tipo_pagamento', 1) },
        { campo: 'clientePagador', label: this.$tc('label.cliente_pagador', 1), hint: 'cnpj' },
        { campo: 'fornecedorPagador', label: this.$tc('label.fornecedor_pagador', 1), hint: 'cnpj' },
        { campo: 'prazoVencimentoAcao', label: this.$tc('label.prazo_vencimento_dias', 1) },
        { campo: 'tiposVerbas', label: this.$tc('label.tipo_de_verba', 1), i18n: true },
      ],
    };
  },
  computed: {
  },
  methods: {
    formatarObjeto() {
      const acaoFormatada = { ...this.acao };
      if (this.acao && this.acao.tipoPagamento) {
        acaoFormatada.tipoPagamento = this.$tc(`tipos_pagamentos.${this.acao.tipoPagamento.toUpperCase()}`, 1);
      }
      return acaoFormatada;
    },
  },
};
</script>
